import React from 'react';
import { Route, RouteProps } from 'react-router';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { Actions as userActions } from 'reducers/user';
import { IRootState } from 'reducers';

interface IProps {
  isAuthenticated: boolean;
  getLoginStatus: () => any;
  component: any;
}

interface IState {
  isLogined: boolean;
  isRequestComplete: boolean;
}

export class PrivateRoute extends React.Component<IProps & RouteProps, IState> {
  public state = {
    isRequestComplete: false,
    isLogined: this.props.isAuthenticated,
  };

  public componentDidMount() {
    if (!this.state.isLogined) {
      this.makeRequest();
    }
  }

  public componentWillReceiveProps(props: IProps) {
    this.setState({ isRequestComplete: true });
    if ((props.isAuthenticated) && !(this.state.isLogined)) {
      this.setState({ isLogined: true });
    }
  }

  public makeRequest() {
    this.props.getLoginStatus();
  }

  public render() {
    const {
      component: Component,
      isAuthenticated,
      ...rest
    } = this.props;
    return (
      <div>
        {
          this.state.isRequestComplete ?
            (<Route
              {...rest}
              render={props => (
                this.state.isLogined ? (
                  <Component {...props} />
                ) :
                  (
                    <Redirect
                      to={{
                        pathname: '/auth',
                        state: { from: props.location },
                      }}
                    />
                  )
              )
              }
            />) : (
              <Route
                {...rest}
                render={props => (
                  this.state.isLogined ? (
                    <Component {...props} />
                  ) :
                    (
                      <div />
                    )
                )
                }
              />
            )
        }
      </div>
    );
  }
}

const actions = {
  getLoginStatus: userActions.loginRequest,
};

const mapStateToProps = ({ user }: IRootState) => ({
  isAuthenticated: user.isAuthenticated,
});

export default connect(mapStateToProps, actions)(PrivateRoute);
